import styled from "styled-components";
import BluePause from "../../../../../components/Images/BluePause";
import InfoIcon from "../../../../../components/Images/InfoIcon";

const VoiceContainer = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
`

const Header = styled.div`
    display:flex;
    flex-direction: column;
    flex-shrink: 0;
`

const VoiceTabHolder = styled.div`
    display: flex;  
`

const VoiceTab = styled.div`
    display: flex;
    justify-content: ${({ genreTab }) => genreTab ? 'unset' : 'center'};
    flex: 1;
    align-items: center;
    cursor: pointer;
    border-bottom: ${({ active }) => `solid 1px ${active ? 'var(--Text700)' : 'rgba(13, 21, 54, 0.2)'}`} ;
    padding: 8px 0;
`

const TabSpan = styled.p`
    text-transform: capitalize;
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    text-align: center;
    width: 100%;
    color: ${({ active }) => active ? 'var(--Text700)' : 'var(--Text300)'} ;
`
const ListDiv = styled.div`
    flex: 1;
    overflow-x: hidden;
    overflow-y: auto;
    background-color: #eeeeee;
`

const VoiceItem = styled.div`
    display: flex;
    align-items: center;
    background-color: ${({ selected}) => selected ? 'rgba(6, 138, 226, 0.24)' : 'var(--bg-alt)'};
    margin-bottom: 1px;
    padding: 8px 16px;
`

const Footer = styled.div`
    background-color: #FAFAFA;
    padding: 16px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
    gap: 8px;
    box-shadow: 16px 16px 16px 16px #d0d0d0;
`

const CautionCard = styled.div`
    background-color: var(--corn-op-8);
    border: solid 1px var(--corn-op-24);
    padding: 8px;
    border-radius: 32px;
    display: flex;
    align-items: center;
    gap: 8px;
`

const CautionText = styled.p`
    font-size: 14px;
    color: var(--corn-800);
    font-weight: bold;
    line-height: 1.43;
    text-align: center;
`

const VoiceNameText = styled.div`
    font-weight: 700;
    font-size: 16px;
    line-height: 20px;
    text-transform: capitalize;
    color:var(--Text700);
    overflow: hidden;
    text-wrap: nowrap;
    text-overflow: ellipsis;
`
const GenreAgeText = styled.div`
    overflow: hidden;
    margin-top: 4px;
    height: 20px;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 14px;
    font-weight: 600;
    line-height: 16px;
    color: var(--Text300);
    text-transform: capitalize;
`

const SelectedGenreAgeText = styled(GenreAgeText)`
    color: var(--Text500);
    position: relative;
`

const TransformationTxt = styled.span`
    animation: ${({ isScrolling }) => isScrolling ? 'scroll 10s linear infinite' : 'unset'};
    display: inline-block;
    @keyframes scroll {
        0% {
            transform: translateX(0%);
        }
        100% {
            transform: translateX(-100%);
        }
    }
`

const PlayPauseBtn = styled.button`
    background-color: unset;
    border: none;
`

const CircularProgress = styled.div`
    position: relative;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background: conic-gradient(#068AE2 ${({ angle }) => `${angle}deg` || '0deg'},#ededed 0deg);
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.2s smooth;
    :before{
        content: "";
        position: absolute;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        background-color: white;
    }
`

const PauseIcon = styled(BluePause)`
    position: relative;
`

const HeadingInfoIcon = styled(InfoIcon)`
    width: 16px;
    height: 16px;
    margin-left: 8px;
`

export {
    PlayPauseBtn,
    GenreAgeText,
    TransformationTxt,
    CautionCard,
    VoiceContainer,
    Header,
    VoiceTabHolder,
    VoiceTab,
    TabSpan,
    Footer,
    ListDiv,
    VoiceItem,
    VoiceNameText,
    CircularProgress,
    PauseIcon,
    SelectedGenreAgeText,
    HeadingInfoIcon,
    CautionText
}